import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const BUTTON_STYLE = {
  width: 32,
  height: 32,
  padding: 0,
};

const WRAPPER_STYLE = {
  display: "inline-flex",
  flex: "0 0 32px",
};

export default function DownloadIconButton({
  title = "Download",
  disabledTitle,
  disabled = false,
  onClick,
  size = "small",
  style,
  wrapperStyle,
  ariaLabel = "Download",
}) {
  return (
    <Tooltip title={disabled && disabledTitle ? disabledTitle : title}>
      <span style={{ ...WRAPPER_STYLE, ...wrapperStyle }}>
        <Button
          size={size}
          icon={<DownloadOutlined />}
          disabled={disabled}
          onClick={onClick}
          style={{ ...BUTTON_STYLE, ...style }}
          aria-label={ariaLabel}
        />
      </span>
    </Tooltip>
  );
}
